import { AimsCommonTableHeader } from '@aims/common-components';
import { ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { InvInventoryItem } from 'src/models';

@Component({
  selector: 'app-add-inventory-item',
  templateUrl: './add-inventory-item.component.html',
  styleUrls: ['./add-inventory-item.component.css']
})
export class AddInventoryItemComponent implements OnInit {

  @ViewChild('quantity') quantity: ElementRef;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  inventoryItem: InvInventoryItem = new InvInventoryItem();
  partQuantity: number = 0;
  quantityOnHand: number = 0;

  @Input() IsWorkOrder: boolean = false;
  @Output() AddInventoryItemEvent = new EventEmitter();

  public inventory = this.transferHttp.get('inventory/GetInventoryItems');

  itemLookupColumns: AimsCommonTableHeader[] = [
    { key: 'barcode', label: 'Barcode', type: 'number'},
    { key: 'description', label: 'Description', type: 'string'},
    { key: 'partNo', label: 'Part #', type: 'string'}
  ];


  constructor(private transferHttp: TransferHttpService) { }

  ngOnInit(): void {
  }

  public onValueChange(event) {
    var x = event.target.value;
    if (x.length == 16) {
      this.loadInventoryItem();
    }
  }

  public inventoryBarcodeToAdd;

  public handleItemLookupChange(event) {
    this.inventoryItem.barcode = event;
    this.loadInventoryItem();
  }

  loadInventoryItem(): void {
      this.spinnerText = "Loading Inventory Item...";
      this.showSpinner = true;
      this.transferHttp.get(`inventory/GetInventoryItem?barcode=${this.inventoryItem.barcode}` ).subscribe(inventoryItem => {
        if (inventoryItem) {
          this.inventoryItem = inventoryItem;
          this.partQuantity = (inventoryItem.assemblyIssued) ? 1 : 0;

          this.quantityOnHand = this.getInventoryItemQuantity();
          this.focusOnQuantity();
        }
        else {
          // unknown inventory item barcode
          this.inventoryItem.description = "";
          this.inventoryItem.unitOfIssue = null;
          this.inventoryItem.inventoryItemId = 0;
          this.quantityOnHand = 0;
          this.inventoryItem.assemblyIssued = false;
        }
        this.showSpinner = false;
      });
  }

  public getInventoryItemQuantity(): number {
    const sum: number = this.inventoryItem?.invInventoryItemReceived?.map(i => i.quantity)
                        .reduce((sum, current) => sum + current, 0) ?? 0;
    return sum;
  }

  public addItem() {
    if (this.partQuantity == 0) {
      alert("must have quantity greater than zero.")
      return;
    }

    let desiredQuantity = this.partQuantity;

    if (desiredQuantity > this.quantityOnHand) {
      alert("insufficient quantity available");
    }
    else {
      this.AddInventoryItemEvent.emit({ inventoryItemId: this.inventoryItem.inventoryItemId, quantity: this.partQuantity, inventoryItem: this.inventoryItem });
      this.clearAddPart();
    }
  }

  public clearAddPart(): void {
    this.inventoryItem.barcode = "";
    this.inventoryItem.description = "";
    this.inventoryItem.assemblyIssued = false;
    this.inventoryItem.unitOfIssue = null;
    this.inventoryItem.inventoryItemId = 0;
    this.quantityOnHand = 0;
    this.partQuantity = 0;
  }

  private focusOnQuantity() {
    setTimeout(() => {
      this.quantity?.nativeElement?.focus();
    },0);
  }

}
